import { render, staticRenderFns } from "./InsightsRouterView.vue?vue&type=template&id=96663046&"
import script from "./InsightsRouterView.vue?vue&type=script&lang=js&"
export * from "./InsightsRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports